<div style="position: absolute; top: 0; left: 0; width: 100%">
  <nav
    class="navbar navbar-expand navbar-white navbar-light"
    style="margin-left: 0px; border-bottom: 1px solid #B5B5B6; padding-left: 0;"
  >
    <a [routerLink]="['/wf-login']">
      <img
        src={{logoUrl}}
        alt="AdminLTE Logo"
        class="brand-image"
    /></a>
  </nav>
</div>
<div class="login-box">
  <div class="login-logo">
    <i class="warning"></i>
    <p id="err_title1" class="error-text">
    </p>
  </div>
  <div class="text-center">
    <p id="err_text1" class="error-text-black"></p>
  </div>
</div>
